import { createReducer, createActions } from 'reduxsauce';
import update from 'immutability-helper';
import type { Order } from 'contracts/Orders';

const { Types, Creators } = createActions(
  {
    request: ['query', 'onSuccess', 'onFailure'],
    success: ['data'],
    failure: ['errorMessage'],
    softReset: [],
    reset: [],
  },
  {
    prefix: 'EXPORT_ORDERS_',
  }
);

export interface ExportOrdersState {
  data: Order[];
  loading: boolean;
  errorMessage: string | null;
}

export interface ExportOrdersRequestAction {
  query?: Record<string, any>;
  onSuccess?: (data: Order[]) => void;
  onFailure?: () => void;
}

interface SuccessAction {
  data: Order[];
}

interface FailureAction {
  errorMessage: string;
}

const INITIAL_STATE: ExportOrdersState = {
  data: [],
  loading: false,
  errorMessage: null,
};

const request = (state: ExportOrdersState) =>
  update(state, {
    loading: { $set: true },
    errorMessage: { $set: null },
  });

const success = (state: ExportOrdersState, action: SuccessAction) =>
  update(state, {
    loading: { $set: false },
    data: { $set: action.data },
  });

const failure = (state: ExportOrdersState, action: FailureAction) =>
  update(state, {
    loading: { $set: false },
    errorMessage: { $set: action.errorMessage },
  });

const softReset = (state: ExportOrdersState) =>
  update(state, {
    loading: { $set: false },
  });

const reset = () => INITIAL_STATE;

export const exportOrders = createReducer(INITIAL_STATE, {
  [Types.REQUEST]: request,
  [Types.SUCCESS]: success,
  [Types.FAILURE]: failure,
  [Types.SOFT_RESET]: softReset,
  [Types.RESET]: reset,
});

export const ExportOrdersTypes = Types;
export const ExportOrdersActions = Creators;
